import {
    ThemeProvider,
    createTheme,
    CssBaseline,
    Box,
    Drawer,
    AppBar,
    Toolbar,
    Typography,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    IconButton,
    Grid,
    Paper,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    LinearProgress,
    Avatar,
    Menu,
    MenuItem,
    useTheme,
} from "@mui/material";
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    Add as AddIcon,
  } from '@mui/icons-material';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import MoreVertIcon from '@mui/icons-material/MoreVert';

import FlexBetween from "components/FlexBetween";

import { useGetEmployeesQuery, useGetAllClockingsQuery, useGetAllBreaksQuery, useDeleteEmployeeMutation, useResetEmployeePinMutation, useUpdateEmployeeMutation, useCreateEmployeeMutation } from "../../state/api";

const Projects = () => {
    const theme = useTheme();
    const isMobileScreen = useMediaQuery('(max-width:768px)'); 

    const projects = [
        { title: 'Postman', description: 'Advanced API testing for various clients', image: 'https://placehold.co/100x100/1e293b/00bcd4?text=API' },
        { title: 'Git', description: 'Led version control in large projects', image: 'https://placehold.co/100x100/1e293b/00bcd4?text=VCS' },
        { title: 'Java', description: 'Developed a scalable web application', image: 'https://placehold.co/100x100/1e293b/00bcd4?text=Web' },
    ];

  return (
    <Box>
        <Paper sx={{ p: 2, borderRadius: '0.75rem' }}>
            <FlexBetween mb={2}>
                <Typography variant="h4">Featured Projects</Typography>
                <Button variant="contained" startIcon={<AddIcon />}>Add New Project</Button>
            </FlexBetween>
            <TableContainer>
                <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Image</TableCell>
                        <TableCell>Title</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell align="right">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {projects.map(p => (
                    <TableRow key={p.title}>
                        <TableCell><Avatar src={p.image} variant="rounded" sx={{ width: 56, height: 56 }} /></TableCell>
                        <TableCell>{p.title}</TableCell>
                        <TableCell>{p.description}</TableCell>
                        <TableCell align="right">
                            <IconButton size="small"><EditIcon /></IconButton>
                            <IconButton size="small"><DeleteIcon /></IconButton>
                        </TableCell>
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    </Box>
    )

}

export default Projects;

